module.exports = __webpack_public_path__ + "static/media/icon.949106f1.svg";